import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';

import { getStore } from '../../../../common/redux/store-utils';

import ExpiredPanel from './components/Panel';
import AuthScreenLayout from '../../components/AuthScreenLayout';
import { registerState } from '../../../../common/Services/RegistrationService.js';

import { isSupportedBrowser } from '../../common/utils';
import UnsupportedBrowsers from '../../components/UnsupportedBrowsers';

const namespace = 'expiredPanel';
const FORM_ID = 'expiredPasswordForm';

import reducer from './redux/reducer';
import saga from './redux/sagas';

const store = getStore();

const createExpiredScreen = () => {
  const root = createRoot(document.getElementById('expiredPanel'));
  if (isSupportedBrowser()) {
    registerState({
      namespace,
      reducers: reducer,
      sagas:    [saga],
    });

    root.render(
      <Provider store={store}>
        <AuthScreenLayout>
          <ExpiredPanel />
        </AuthScreenLayout>
      </Provider>
    );
  } else {
    root.render(<UnsupportedBrowsers />);
  }
};

window.createExpiredScreen = createExpiredScreen;
export { namespace, FORM_ID };
